import { DELIVERY_SMZ_URL, DELIVERY_WITHOUT_SMZ_URL, FLEET_URL } from './constants.js'

// Park conditions confirmed by the owner on 2026-09-07, not universal Yandex rates.
export const DELIVERY_WITHOUT_SMZ_TERMS = 'Общая комиссия без СМЗ динамическая — до 12–15% от заказа. Точный процент увидите после первого заказа; со стажем работы комиссия снижается.'

const deliverySteps = [
  ['Заполните выбранную анкету', 'Укажите свой город и номер, с которым будете входить в Яндекс Про. Если анкету уже отправили, повторно заполнять её не нужно.'],
  ['Войдите в Яндекс Про', 'Используйте тот же номер телефона. В профиле выберите парк ABG logist. Если его нет в списке, напишите парку — поможем проверить подключение.'],
  ['Подготовьтесь к первому заказу', 'Проверьте выбранный способ доставки и выполните подсказки приложения. До выхода посмотрите доступные заказы, условия и требования к экипировке.'],
]

export const registrationRoutes = Object.freeze({
  delivery_smz: {
    id: 'delivery_smz', service: 'delivery', title: 'Доставка с самозанятостью',
    href: DELIVERY_SMZ_URL, label: 'Открыть анкету — с СМЗ',
    benefit: '0% комиссии парка',
    terms: 'У самозанятых в Яндекс Доставке комиссия нашего парка — 0%. Налог оплачивается отдельно; условия сервиса смотрите в Яндекс Про.',
    steps: deliverySteps,
  },
  delivery_without_smz: {
    id: 'delivery_without_smz', service: 'delivery', title: 'Доставка без самозанятости',
    href: DELIVERY_WITHOUT_SMZ_URL, label: 'Открыть анкету — без СМЗ',
    benefit: 'Можно подключиться без СМЗ', terms: DELIVERY_WITHOUT_SMZ_TERMS,
    steps: deliverySteps,
  },
  taxi_smz: {
    id: 'taxi_smz', service: 'taxi', title: 'Такси с самозанятостью',
    href: FLEET_URL, label: 'Открыть анкету водителя',
    benefit: 'Подключение к парку ABG Taxi',
    terms: 'В такси наш парк подключает только самозанятых. До выхода уточните комиссию, требования к автомобилю и документы для работы в вашем городе.',
    steps: [
      ['Заполните анкету водителя', 'Укажите город, свой телефон и точные данные автомобиля. Подготовьте паспорт, водительское удостоверение и СТС.'],
      ['Дождитесь проверки подключения', 'Парк подскажет, если нужны дополнительные сведения. Отправленная анкета ещё не означает допуск к заказам.'],
      ['Проверьте Яндекс Про', 'Войдите с номером из анкеты. Проверьте парк ABG Taxi, автомобиль, статус самозанятости и выполните необходимые проверки перед выходом.'],
    ],
  },
})

export function resolveRegistration(service, smz) {
  if (!['delivery', 'taxi'].includes(service) || !['yes', 'no'].includes(smz)) return null
  if (service === 'taxi' && smz === 'no') return null
  return registrationRoutes[service === 'taxi' ? 'taxi_smz' : smz === 'yes' ? 'delivery_smz' : 'delivery_without_smz']
}
